import { useState } from "react";
import styled from "styled-components";
import { Modal } from "react-bootstrap";

const NavLinkButton = styled.button`
  background: none;
  border: none;
  width: 100%;
  text-align: left;

  display: flex;
  align-items: center;
  gap: 8px;

  color: inherit;
  font: inherit;
  cursor: pointer;
  margin-top:12px;
  transition:all ease-in 0.3s;

  &:hover{
  color:var(--secondary-color);
  }

`;

const PreviewIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
`;

const ModalBodyWrapper = styled.div`
  height: 80vh;
`;

export default function LivePreviewButton({
  url,
  innerText,
  onClick,
  className,
  style,
  icon:Icon,
}) {
  const [show, setShow] = useState(false);

  return (
    <>
      <NavLinkButton
        className={className}
        style={style}
        onClick={() => {
          setShow(true);
          onClick?.();
        }}
      >
      { Icon && <Icon /> }
        {innerText}
      </NavLinkButton>

      <Modal
        show={show}
        onHide={() => setShow(false)}
        size="xl"
        centered
        backdrop="static"
      >
        
        <Modal.Header closeButton>
          <Modal.Title>Quick Preview</Modal.Title>
        </Modal.Header>

        <ModalBodyWrapper>
          <PreviewIframe src={url} title="Live Preview" />
        </ModalBodyWrapper>
      </Modal>
    </>
  );
}
